import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CdnPrefixPipe } from './cdn-prefix.pipe';
import { ResourceLinkPipe } from './resource-link.pipe';
import { CrossOriginLinkPipe } from './cross-origin-link.pipe';
import { CignaSecureCdnContentDirective } from './cigna-secure-cdn-content.directive';

@NgModule({
  imports: [CommonModule],
  declarations: [
    CdnPrefixPipe,
    ResourceLinkPipe,
    CrossOriginLinkPipe,
    CignaSecureCdnContentDirective,
  ],
  exports: [
    CdnPrefixPipe,
    ResourceLinkPipe,
    CrossOriginLinkPipe,
    CignaSecureCdnContentDirective,
  ],
})
export class ChcpSharedEnvironmentUtilModule {}
